module.exports = __webpack_public_path__ + "img/side-qywx.38ee28fe.png";